import { Outlet } from "react-router-dom";
import DisclaimerBanner from "./DisclaimerBanner";
import Header from "./Header";
import Footer from "./Footer";

export const Layout = () => (
  <div className="App min-h-screen flex flex-col bg-white">
    <DisclaimerBanner />
    <Header />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default Layout;
